import { render, staticRenderFns } from "./MyItem.vue?vue&type=template&id=4a0b0e2c&scoped=true&"
import script from "./MyItem.vue?vue&type=script&lang=js&"
export * from "./MyItem.vue?vue&type=script&lang=js&"
import style0 from "./MyItem.vue?vue&type=style&index=0&id=4a0b0e2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0b0e2c",
  null
  
)

export default component.exports